<template>
<div class="v-echarts"></div>
</template>

<script>
import { debounce } from 'lodash-es'
import echarts from './config'
export default {
    props: {
        options: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            echarts: null
        }
    },
    watch: {
        options: {
            deep: true,
            immediate: true,
            handler (v) {
                if (v && v.series) {
                    this.init()
                }
            }
        }
    },
    methods: {
        init () {
            this.$nextTick(() => {
                if (!this.echarts) {
                    this.echarts = echarts.init(this.$el)
                }
                this.echarts.setOption(this.options, true)
                this.bindEvent()
            })
        },
        bindEvent () {
            this.resizeHandler = debounce(() => {
                this.echarts && this.echarts.resize()
            }, 200)
            window.addEventListener('resize', this.resizeHandler)
        }
    },
    destoryed () {
        window.removeEventListener('resize', this.resizeHandler)
    }
}
</script>

<style lang="less">
.v-charts {
    width: 100%;
    height: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/echarts/index.vue